import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import FormLabel from '@mui/material/FormLabel';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import FormHelperText from '@mui/material/FormHelperText';
import RequiredLabel from '@ui-elements/RequiredLabel';
import InputValidationErrorBox from '@ui-parts/InputValidationErrorBox';

import { FONT_SIZES, BASE_FONT_COLOR } from '~/assets/styles/base';

const StyledSelect = styled(Select)`
  padding: 0;
  font-size: ${FONT_SIZES.body3};
  color: ${BASE_FONT_COLOR};
  height: ${({ $height }) => $height};
  svg {
    color: ${BASE_FONT_COLOR};
  }
`;

const StyledFormLabel = styled(FormLabel)`
  padding: 8px 0;
  font-size: ${FONT_SIZES.body3};
  color: ${BASE_FONT_COLOR};
`;

const ValidationError = styled(FormHelperText)`
  position: relative;
`;

/* istanbul ignore next 直接定義するとなぜかカバレッジ通らない（ignoreもできない）のでここで定義 */
const defHandleChange = () => {};

function SelectBoxWithLabel({
  required = false,
  label,
  disabled = false,
  name = null,
  value,
  error,
  errorPosition = 'center',
  displayEmpty = true,
  height = '39px',
  dataTestId = 'uiParts-SelectBoxWithLabel-SelectBox',
  handleChange = defHandleChange,
  children,
}) {
  return (
    <Box>
      <FormControl fullWidth data-testid="uiParts-SelectBoxWithLabel">
        {required ? (
          <StyledFormLabel>
            <RequiredLabel />
            <Typography variant="body3" color="text.main">
              {label}
            </Typography>
          </StyledFormLabel>
        ) : (
          <StyledFormLabel>{label}</StyledFormLabel>
        )}
        <StyledSelect
          $height={height}
          name={name}
          value={value}
          displayEmpty={displayEmpty}
          disabled={disabled}
          onChange={handleChange}
          error={Boolean(error)}
          data-testid={dataTestId}
        >
          {children}
        </StyledSelect>
        {error && (
          <ValidationError
            component={InputValidationErrorBox}
            message={error.message}
            position={errorPosition}
          />
        )}
      </FormControl>
    </Box>
  );
}

SelectBoxWithLabel.propTypes = {
  required: PropTypes.bool,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: PropTypes.string,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  errorPosition: PropTypes.oneOf(['center', 'centerAbsolute', 'left', 'right']),
  displayEmpty: PropTypes.bool,
  height: PropTypes.string,
  dataTestId: PropTypes.string,
  handleChange: PropTypes.func,
  children: PropTypes.node,
};

export default SelectBoxWithLabel;
